<template>
	<nav class="navbar navbar-expand-lg navbar-light bg-light">
	  <div class="collapse navbar-collapse" id="navbarSupportedContent">
	    <ul class="navbar-nav mr-auto">
	      <li class="nav-item">
	        <a class="nav-link" href="#/">RCOS 2017</a>
	      </li>
	    </ul>
	  </div>
	</nav>
</template>

<script>
export default {}
</script>



// WEBPACK FOOTER //
// src/containers/app_footer/components/layout.vue